module.exports = __webpack_public_path__ + "assets/images/alert.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/alert.png
// module id = 176
// module chunks = 1